/**
 * Shared accent/surface colors for delivery status count cards
 * (listing filters and dashboard STATUS_COUNT_LIST).
 */

export function statusCountAccent(theme, token) {
    const t = theme?.colors || {};
    const map = {
        gray: t.gray?.[500] || '#6B7280',
        amber: t.warning?.main || '#D97706',
        blue: t.info?.main || '#2563EB',
        indigo: t.indigo?.main || '#6366F1',
        teal: t.teal?.main || '#14B8A6',
        orange: t.orange?.main || '#F97316',
        green: t.success?.main || '#16A34A',
        red: t.danger?.main || '#DC2626',
    };
    return map[token] || map.gray;
}

export function statusCountSurface(theme, token) {
    const t = theme?.colors || {};
    const map = {
        gray: t.gray?.[100] || '#E6E6E6',
        amber: t.warning?.light || '#FFFBEB',
        blue: t.info?.light || '#EFF6FF',
        indigo: t.indigo?.light || '#EEF2FF',
        teal: t.teal?.light || '#F0FDFA',
        orange: t.orange?.light || '#FFF7ED',
        green: t.success?.light || '#F0FDF4',
        red: t.danger?.light || '#FEE2E2',
    };
    return map[token] || map.gray;
}
